import ClueDetailNewPage from "@/pages/clueManage/clueDetail";
import {useParams} from "react-router-dom";

export default function SaleSeaDetail(){
  const {id} = useParams()
  return <ClueDetailNewPage id={id} viewPhoneKey={'salePublicInfoViewPhone'}/>
}